function getRGBFromHex(hex, toString = false) {
    const rgb = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));

    return toString ? `rgb(${rgb})` : rgb;
}

function roundNumber(number, precision = 0) {
    const multiplier = 10 ** precision;
    const positiveNumber = Math.round(Math.abs(number * multiplier));
    const signedNumber = number < 0 ? -1 * positiveNumber : positiveNumber;

    return signedNumber / multiplier;
}

export { getRGBFromHex, roundNumber };
